import React from 'react';
import {Container,Row,Col} from 'reactstrap';

const Footer = ({ footerLine }) =>  {
  if (!footerLine) return null;
  return (
        <footer className="footer">
          <Container fluid={true}>
            <Row>
              <Col md="6" className="footer-copyright">
                <p className="mb-0">{footerLine}</p>
              </Col>
            </Row>
          </Container>
        </footer>
    );
};

export default Footer;
